const month = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember'
]
const shortMonth = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mei',
  'Jun',
  'Jul',
  'Agu',
  'Sep',
  'Okt',
  'Nov',
  'Des'
]

export function useFormatDate (date) {
  const splitedDate = date.split('T')[0]

  return convertDate(splitedDate)
}

export function convertDate (date) {
  const splitedDate = date.split('-')

  return `${splitedDate[2]} ${month[splitedDate[1] - 1]} ${splitedDate[0]}`
}

export function logger (msg) {
  // eslint-disable-next-line no-console
  return process.env.NODE_ENV === 'production' ? msg : console.log(msg)
}
export function monthName (date) {
  return month[date.getMonth()]
}

export function shortMonthName (date) {
  return shortMonth[date.getMonth()]
}
